import { toast } from 'sonner';
import { useZugangErstellen } from '../hooks/useZugangErstellen.ts';
import { ZugangFormular } from '../components/ZugangFormular.tsx';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import type { EndpunktDefinitionInput } from '../gql/graphql.ts';

const FEHLERTEXTE = {
  limitErreicht: 'domain.e2nApi.neuerZugang.limitErreicht',
  titelZuLang: 'domain.e2nApi.neuerZugang.titelZuLang',
  fehlgeschlagen: 'domain.e2nApi.neuerZugang.fehler',
} as const;

export function NeuerZugangPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { erstellen, loading } = useZugangErstellen();

  async function handleErstellen(
    titel: string,
    definitionen: EndpunktDefinitionInput[],
  ): Promise<void> {
    const ergebnis = await erstellen(titel, definitionen);

    if (ergebnis === 'erfolg') {
      toast.success(t('domain.e2nApi.neuerZugang.erfolg.title'), {
        description: t('domain.e2nApi.neuerZugang.erfolg.description'),
      });
      navigate('..');
      return;
    }

    if (ergebnis === 'endpunkteFehlgeschlagen') {
      toast.warning(t('domain.e2nApi.neuerZugang.endpunkteFehler'));
      navigate('..');
      return;
    }

    toast.error(t(FEHLERTEXTE[ergebnis]));
  }

  return (
    <ZugangFormular
      titel={t('domain.e2nApi.neuerZugang.title')}
      startAuswahl={{}}
      startTitel=""
      laeuft={loading}
      absendenText={t('domain.e2nApi.karte.erstellen')}
      onAbsenden={handleErstellen}
    />
  );
}
